import PropTypes from "prop-types";
import KycReminderModal from "./kyc-reminder-modal";
import { toReminderRecipient } from "../misc/kyc";

// The reminder preview, driven by one usePublisherKyc() — mount once per view.
const KycReminderDialog = ({ kyc }) => (
    <KycReminderModal
        open={Boolean(kyc.reminder)}
        onClose={kyc.closeReminder}
        brandName={kyc.reminder?.brand?.name || "your brand"}
        brands={kyc.reminder?.bulk ? [] : kyc.reminder?.brands}
        brandId={kyc.reminder?.brand?.id}
        onBrandChange={kyc.selectReminderBrand}
        recipients={(kyc.reminder?.publishers || []).map(toReminderRecipient)}
        onSend={kyc.sendReminder}
        sending={kyc.sending} />
);

KycReminderDialog.propTypes = {
    kyc: PropTypes.object.isRequired
};

export default KycReminderDialog;
